/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Flyer8Inputs */

const en__field_enum_mzs_flyer8 = /** @type {(inputs: _Field_Enum_Mzs_Flyer8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`flyer/posters`)
};

const de__field_enum_mzs_flyer8 = /** @type {(inputs: _Field_Enum_Mzs_Flyer8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer/Plakate`)
};

/**
* | output |
* | --- |
* | "flyer/posters" |
*
* @param {_Field_Enum_Mzs_Flyer8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_flyer8 = /** @type {((inputs?: _Field_Enum_Mzs_Flyer8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Flyer8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_flyer8(inputs)
	return de__field_enum_mzs_flyer8(inputs)
});
export { _field_enum_mzs_flyer8 as "_field_enum_MZS_FLYER" }